(function () {
  function initExpertTestimonials(section) {
    var tabs = section.querySelectorAll('.expert-tab');
    var panels = section.querySelectorAll('.expert-panel');

    if (!tabs.length) return;

    function activate(index) {
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      if (tabs[index]) tabs[index].classList.add('is-active');
      if (panels[index]) panels[index].classList.add('is-active');
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i); });
    });

    activate(0);
  }

  function init() {
    document.querySelectorAll('.expert-testimonials').forEach(function (section) {
      initExpertTestimonials(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.expert-testimonials');
    if (section) initExpertTestimonials(section);
  });
})();
